const title = "北京智胜远景科技有限公司";//可以在这里直接定义，也可以在一个地方统一设置再在这里引入

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    // return `${pageTitle} - ${title}`;//每页的标题+公司名称
    return ` ${title}`;//只展示公司的名称
  }
  return `${title}`;
}